import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import UsersTab from './users/UsersTab';
import RolePermissionsTab from './rolePermissions/RolePermissionsTab';
import AppSettingsTab from './appSettings/AppSettingsTab';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { getAllEmployeesAsync } from '@application/features/auth/authThunks';
import { useAppDispatch } from '@application/store/useStore';
const SettingsView = () => {
    const dispatch = useAppDispatch();
    VnDocumentTitle('Visser Beheer');
    const [activeTab, setActiveTab] = useState('UsersTab');
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
        if (tabKey === 'UsersTab') {
            dispatch(getAllEmployeesAsync());
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsx("div", { className: 'vn-Workorder-Titlebar', children: _jsx("h4", { className: 'vn-Workorder-Title', children: "Beheer" }) }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'UsersTab', title: 'Gebruikers', children: _jsx(UsersTab, {}) }), _jsx(Tab, { eventKey: 'RolePermissionsTab', title: 'Rolmachtigingen', children: _jsx(RolePermissionsTab, {}) }), _jsx(Tab, { eventKey: 'AppSettingsTab', title: 'Applicatie-instellingen', children: _jsx(AppSettingsTab, {}) })] })] }) }));
};
export default SettingsView;
